import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  ButtonToolbar
} from 'react-bootstrap';
import SubmitButton from './SubmitButton.jsx';
import Form from './Form.jsx';
import styles from './HorizontalStepper.css';

function Step({enableNextStepButton, onCancel, onNext, onBack, submitText, hideBackButton, hideNextButton, hideAllButtons, children}) {
  return (
    <Form onSubmit={onNext}>
      <div className={styles.body}>
        {children}
      </div>
      {
        hideAllButtons ||
          <div>
            <hr/>
            <div className={styles.footer}>
              <ButtonToolbar>
                <Button bsStyle="warning" onClick={onCancel}>Cancel</Button>
              </ButtonToolbar>
              <ButtonToolbar>
                {
                  hideBackButton ||
                    <Button onClick={onBack}>Previous Step</Button>
                }
                {
                  hideNextButton ||
                    <SubmitButton enabled={enableNextStepButton}>{submitText}</SubmitButton>
                }
              </ButtonToolbar>
            </div>
          </div>
      }
    </Form>
  );
}

Step.propTypes = {
  enableNextStepButton: PropTypes.bool,
  title: PropTypes.string.isRequired,
  submitText: PropTypes.node,
  onBack: PropTypes.func,
  onNext: PropTypes.func,
  onCancel: PropTypes.func,
  hideAllButtons: PropTypes.bool,
  hideBackButton: PropTypes.bool,
  hideNextButton: PropTypes.bool
};

Step.defaultProps = {
  enableNextStepButton: true,
  submitText: "Next Step",
  onBack: () => {},
  onNext: () => {},
  onCancel: () => {}
};

export default Step;